<template>
  <div class="container">
    <div :class="level=='孵化级'?'headerImg':level=='成长级'?'headerImg2':'headerImg3'">
        <div class="mainTitle">{{ title }}</div>
    </div>
    <div class="main">
        <div v-for="item,i in list" :key="i" class="rowItem">
            <img src="../../assets/14.png" alt="" class="rowIcon">
            <div class="overHidden">{{ item.standardClause }}</div>
        </div>
    </div>
  </div>
</template>

<script>
import { getNewList } from "@/api/index.js";
export default {
    name: "newList",
    data() {
        return {
            title:'孵化级，入库标准',
            list:[
                {standardClause:'在浙江省境内注册登记、具有独立法人资格和推荐主体推荐、符合《中小企业划型标准规定》的创新型中小微企业。推荐主体中，大型投融资机构按《金融业企业划型标准规定》界定，产业链链主、专精特新“小巨人”、制造业单项冠军等企业以主管部门提供的名单为准'},
                {standardClause:'主营业务原则上属于专利密集型产业，详见《知识产权(专利)密集型产业统计分类(2019)》(国家统计局令第25号)'},
                {standardClause:'专利技术具有产品化、产业化前景'},
                {standardClause:'主营产品的核心功能、制造方法等具有自研或引进的核心专利技术'},
                {standardClause:'具备基本的知识产权管理人员、制度支持与高校、科研机构建立产学研合作机制或加入产业知识产权联盟或获得专利奖项的中小企业入库'},
                {standardClause:'无非正常申请专利行为和各类重大事故、违法违规及严重失信等情况，非正常专利确因系统误判或已整改到位的除外'},
                {standardClause:'无非正常申请专利行为和各类重大事故、违法违规及严重失信等情况，非正常专利确因系统误判或已整改到位的除外'},
            ],
            level:'',
        }
    },
    mounted(){
        console.log(this.$route.query);
        this.title = this.$route.query.standardLevel +','+ this.$route.query.type
        this.getList()
        this.level = this.$route.query.standardLevel
    },
    methods:{
        getList(){
            getNewList({standardLevel: this.$route.query.standardLevel,type: this.$route.query.type}).then(res=>{
                this.list = res.data
            })
        },
    }
}
</script>

<style>
    .container {
        padding-bottom: 20px;
    }
    .headerImg {
        background-image: url('../../assets/fuhua.png');
        min-width: 1200px;
        height: 180px;
    }
    .headerImg2 {
        background-image: url('../../assets/chengzhang.png');
        min-width: 1200px;
        height: 180px;
    }
    .headerImg3 {
        background-image: url('../../assets/yangban.png');
        min-width: 1200px;
        height: 180px;
    }
    .mainTitle {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #fff;
        text-shadow: 0 0 3px #3f93f6,0 0 3px #3f93f6,0 0 3px #3f93f6,0 0 3px #3f93f6;
    }
    .main {
        width: 1200px;
        min-height: calc(100vh - 421px);
        margin: 0px auto;
        background-color: #fff;
        margin-top: 20px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0px 20px;
    }
    .rowItem {
        padding: 30px 0;
        border-bottom: 1px solid #eee;
        font-size: 17px;
        color: #000;
        display: flex;
    }
    .rowIcon {
        width: 16px;
        height: 18px;
        margin-top: 3px;
        margin-right: 10px;
        flex-shrink: 0;
    }
</style>